import routes from './challenge.routes';

export const challengeModule = {
    routes
};